import { render, staticRenderFns } from "./NoWorkspaceWarning.vue?vue&type=template&id=aeea8076&scoped=true"
import script from "./NoWorkspaceWarning.vue?vue&type=script&lang=js"
export * from "./NoWorkspaceWarning.vue?vue&type=script&lang=js"
import style0 from "./NoWorkspaceWarning.vue?vue&type=style&index=0&id=aeea8076&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aeea8076",
  null
  
)

export default component.exports